import { FontSize, LineHeight, rwd, Spacing, Text as TextComponent } from '@billy/design-system'
import styled from '@emotion/styled'

export const GuideHeaderWrapper = styled.header`
  margin-bottom: ${Spacing.S32};

  ${rwd.equalOrLessThan('tablet')} {
    margin-bottom: ${Spacing.S24};
  }
`

export const Title = styled(TextComponent)`
  margin-bottom: ${Spacing.S24};

  ${rwd.equalOrLessThan('tablet')} {
    margin-bottom: ${Spacing.S16};
    font-size: ${FontSize.TextH2};
    line-height: ${LineHeight.TextH2};
  }
`
